<div class="modal-header bg-dark text-center">
    <h4 class="modal-title">Creazione Nuova <strong>Pratica</strong></h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <i class="icons-office-52"></i>
    </button>
</div>
<div class="modal-body" style="margin-bottom: 30px;">
    <div *ngIf="formError" class="alert alert-danger" role="alert">{{ formError }}</div>

    <div class="form-group">
        <label class="col-sm-3 control-label form-label-aligned m-b-20">Gestione Interna</label>
        <div class="col-sm-9 internal-management-field m-b-20">
            <mat-checkbox color="primary"
                          name="internal-management"
                          [(ngModel)]="request.InternalManagement">
                Invia la mail di creazione solo a studioprofessionalevangelista@gmail.com
            </mat-checkbox>
        </div>
    </div>

    <div class="form-group">
        <label for="customer" class="col-sm-3 control-label form-label-aligned m-b-20">Cliente</label>
        <div class="col-sm-9 m-b-20">
            <ng-select id="customer"
                       name="customer"
                       [items]="customerOptions"
                       bindLabel="label"
                       bindValue="id"
                       [clearable]="true"
                       [searchable]="true"
                       [searchFn]="searchCustomer"
                       appendTo=".modal-content"
                       placeholder="Seleziona un cliente esistente"
                       notFoundText="Nessun cliente trovato"
                       [(ngModel)]="selectedCustomerId"
                       (ngModelChange)="onCustomerChange($event)">
                <ng-template ng-option-tmp let-item="item">
                    <span>{{ item.label }}</span>
                    <small *ngIf="item.hint" class="customer-option-hint">{{ item.hint }}</small>
                </ng-template>
            </ng-select>
        </div>
    </div>

    <div class="form-group" *ngIf="!selectedCustomer">
        <label class="col-sm-3 control-label form-label-aligned m-b-20">Email Cliente</label>
        <div class="col-sm-9 m-b-20">
            <p class="field-hint">Verrà creato un nuovo cliente con queste email e la pratica gli verrà associata. Almeno un indirizzo è obbligatorio.</p>
            <app-customer-emails-editor [(emails)]="newCustomerEmails"></app-customer-emails-editor>
            <p class="field-hint" *ngIf="request.InternalManagement">Con Gestione Interna la mail di creazione non viene inviata a questi indirizzi.</p>
        </div>
    </div>

    <div class="form-group" *ngIf="selectedCustomer">
        <label class="col-sm-3 control-label form-label-aligned m-b-20">Email Cliente</label>
        <div class="col-sm-9 m-b-20">
            <p class="field-hint" *ngIf="selectedCustomer.emails.length">Seleziona almeno un indirizzo. La prima email selezionata resta quella della pratica.</p>
            <p class="field-hint" *ngIf="!selectedCustomer.emails.length">Questo cliente non ha email associate. Annulla la selezione oppure aggiungine una dalla sua anagrafica.</p>
            <div class="email-choice" *ngFor="let email of selectedCustomer.emails; trackBy: trackByEmail">
                <input type="checkbox"
                       class="email-choice-input"
                       [id]="'recipient-email-' + email"
                       [checked]="isRecipientSelected(email)"
                       (change)="toggleRecipient(email, $event)">
                <label class="email-choice-label" [for]="'recipient-email-' + email">{{ email }}</label>
            </div>
            <p class="field-hint" *ngIf="request.InternalManagement && selectedCustomer.emails.length">Con Gestione Interna la mail di creazione non viene inviata a questi indirizzi.</p>
        </div>
    </div>

    <div class="form-group">
        <label for="referrer" class="col-sm-3 control-label form-label-aligned m-b-20">Segnalatore</label>
        <div class="col-sm-9 m-b-20">
            <ng-select id="referrer"
                       name="referrer"
                       [items]="partyOptions"
                       bindLabel="label"
                       bindValue="key"
                       groupBy="group"
                       [selectableGroup]="false"
                       [multiple]="true"
                       [clearable]="true"
                       [searchable]="true"
                       [closeOnSelect]="false"
                       [searchFn]="searchPartyOption"
                       appendTo=".modal-content"
                       placeholder="Seleziona segnalatori o fornitori"
                       notFoundText="Nessun segnalatore o fornitore trovato"
                       [(ngModel)]="selectedPartyKeys">
                <ng-template ng-label-tmp let-item="item">
                    <span class="party-kind" [class.party-kind-supplier]="item.kind === 'supplier'">{{ item.kindLabel }}</span>
                    <span>{{ item.label }}</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                    <span class="party-kind" [class.party-kind-supplier]="item.kind === 'supplier'">{{ item.kindLabel }}</span>
                    <span>{{ item.label }}</span>
                    <small *ngIf="item.hint" class="customer-option-hint">{{ item.hint }}</small>
                </ng-template>
            </ng-select>
            <span class="field-hint">Puoi associare nessuno, uno o più segnalatori e fornitori.</span>
            <span class="field-hint" *ngIf="partyLoadError">{{ partyLoadError }}</span>
        </div>
    </div>

    <div class="form-group">
        <label class="col-sm-3 control-label form-label-aligned m-b-20">
            Tipologia di Pratica
        </label>
        <div class="col-sm-9 request-type-field m-b-20">
            <mat-radio-group id="request-type"
                             name="request-type"
                             [color]="'primary'"
                             (ngModelChange)="onRequestTypeChange()"
                             [(ngModel)]="request.FKIDRequestType">
                <mat-radio-button *ngFor="let requestType of requestTypes"
                                  [value]="requestType.IDRequestType">
                    <span style="font-weight: 400 !important;">{{ requestType.RequestType }}</span>
                </mat-radio-button>
            </mat-radio-group>
        </div>
    </div>

    <div class="form-group" *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7">
        <label class="col-sm-3 control-label form-label-aligned m-b-20">
            Fascia di Investimento:
        </label>
        <div class="col-sm-9 investment-range-field m-b-20">
            <mat-radio-group id="request-investment-range"
                             name="request-investment-range"
                             class="investment-range-group"
                             [color]="'primary'"
                             [(ngModel)]="selectedInvestmentRangeId"
                             (ngModelChange)="onRequestInvestmentRangeChange($event)">
                <mat-radio-button *ngFor="let investmentRange of requestInvestmentRanges"
                                  [value]="investmentRange.IDInvestmentRange">
                    <span style="font-weight: 400 !important;">{{ investmentRange.InvestmentRangeLabel }}</span>
                </mat-radio-button>
            </mat-radio-group>
        </div>
    </div>

    <div class="form-group" *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7">
        <label for="payment-cost-4"
               class="col-sm-3 control-label form-label-aligned m-b-20">Costi Certificazione Contabile 4.0 o Predisposizione</label>
        <div class="col-sm-9 payment-text m-b-20">
            <input type="number"
                   id="payment-cost-4"
                   name="payment-cost-4"
                   class="form-control"
                   min="0"
                   autocomplete="off"
                   [(ngModel)]="request.PaymentCostCertification">
        </div>
    </div>

    <div class="form-group" *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7">
        <label for="payment-cost-3"
               class="col-sm-3 control-label form-label-aligned m-b-20">Costi Perizia Tecnica 4.0</label>
        <div class="col-sm-9 payment-text m-b-20">
            <input type="number"
                   id="payment-cost-3"
                   name="payment-cost-3"
                   class="form-control"
                   min="0"
                   autocomplete="off"
                   [(ngModel)]="request.PaymentCostExpertise">
        </div>
    </div>

    <div class="form-group" *ngIf="request.FKIDRequestType === 1 || request.FKIDRequestType === 6">
        <label for="payment-cost-1"
               class="col-sm-3 control-label form-label-aligned m-b-20">Costi Domanda Nuova Sabatini</label>
        <div class="col-sm-9 payment-text m-b-20">
            <input type="number"
                   id="payment-cost-1"
                   name="payment-cost-1"
                   class="form-control"
                   min="0"
                   autocomplete="off"
                   [(ngModel)]="request.PaymentCost1">
        </div>
    </div>

    <div class="form-group" *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7">
        <label for="payment-cost-2"
               class="col-sm-3 control-label form-label-aligned m-b-20">Costi Iperammortamento 4.0</label>
        <div class="col-sm-9 payment-text m-b-20">
            <input type="number"
                   id="payment-cost-2"
                   name="payment-cost-2"
                   class="form-control"
                   min="0"
                   autocomplete="off"
                   [(ngModel)]="request.PaymentCost2">
        </div>
    </div>

    <div class="form-group total-row">
        <label class="col-sm-3 control-label form-label-aligned">Totale</label>
        <div class="col-sm-9 payment-text total-value">
            € {{ (+request.PaymentCostCertification || 0) + (+request.PaymentCostExpertise || 0) + (+request.PaymentCost1 || 0) + (+request.PaymentCost2 || 0) }}
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default btn-blue btn-embossed" [disabled]="saving" (click)="createRequest()">{{ saving ? 'Creazione...' : 'Crea' }}</button>
    <button type="button" class="btn btn-default btn-embossed" (click)="activeModal.close()">Chiudi</button>
</div>
